import React from "react";
import CustomSelect from "../../../../common/CustomSelect";
import CustomButton from "../../../../common/CustomButton";
import AsteriskStyle from "../../../../Form/Tooltip/AsteriskStyle";
import { furnishedList, roadFacingSides } from "../../../../../Enum";

const PropertyInfoStep = ({
  selectedPropertyType,
  unitInfo,
  formData,
  onInputChange,
  onParkingChange,
  onGenerate,
}) => {
  return (
    <div className="flex flex-col gap-5 p-4">
      {selectedPropertyType === "Layout" && (
        <>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Overall SQ.FT
            </label>
            <div className="col-span-8">
              <input
                type="text"
                value={unitInfo?.sqft || ``}
                readOnly
                className=" focus:outline-none px-3 w-full rounded-[10px] py-2 bg-slate-100"
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Unit Facing Side
            </label>
            <div className="col-span-8">
              <input
                type="text"
                value={unitInfo?.roadFacingSide?.name || ``}
                readOnly
                className="px-3 w-full  focus:outline-none rounded-[10px] py-2 bg-slate-100"
              />
            </div>
          </div>
        </>
      )}

      {(selectedPropertyType === "Villa" ||
        selectedPropertyType === "Apartment") && (
        <>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Saleable Area
            </label>
            <div className="col-span-8">
              <input
                type="text"
                value={unitInfo?.saleableArea || ``}
                readOnly
                className="focus:outline-none px-3 w-full rounded-[10px] py-2 bg-slate-100"
              />
            </div>
          </div>

          {selectedPropertyType === "Villa" ? (
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Total Floor
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  value={unitInfo?.floors || ``}
                  readOnly
                  className=" focus:outline-none px-3 w-full rounded-[10px] py-2 bg-slate-100"
                />
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Unit Floor
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  value={unitInfo?.unitFloor || ``}
                  readOnly
                  className=" focus:outline-none px-3 w-full rounded-[10px] py-2 bg-slate-100"
                />
              </div>
            </div>
          )}

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Total BHK
            </label>
            <div className="col-span-8">
              <input
                type="text"
                value={unitInfo?.totalBhk || ``}
                readOnly
                className=" focus:outline-none px-3 w-full rounded-[10px] py-2 bg-slate-100"
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Furnished <AsteriskStyle />
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={furnishedList.map((list) => ({
                  value: list?.value,
                  label: list?.label,
                }))}
                value={
                  formData.selectedFurnished
                    ? furnishedList.find(
                        (option) => option.value === formData.selectedFurnished
                      )
                    : null
                }
                onChange={(selected) =>
                  onInputChange("selectedFurnished", selected?.value || null)
                }
                placeholder="Select Furnishing Status"
                isClearable
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Fully Covered Parking
            </label>
            <div className="col-span-8 flex items-center gap-3">
              <button
                onClick={() =>
                  onParkingChange(
                    "fullyCovered",
                    formData.parkingOptions.fullyCovered - 1
                  )
                }
                className="bg-white w-12 h-[50px] rounded-[10px] border border-slate-200"
              >
                -
              </button>
              <input
                type="text"
                value={formData.parkingOptions.fullyCovered}
                readOnly
                className="input-focus text-center w-20 rounded-[10px] py-2"
              />
              <button
                onClick={() =>
                  onParkingChange(
                    "fullyCovered",
                    formData.parkingOptions.fullyCovered + 1
                  )
                }
                className="bg-white w-12 h-[50px] rounded-[10px] border border-slate-200"
              >
                +
              </button>
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Semi Covered Parking
            </label>
            <div className="col-span-8 flex items-center gap-3">
              <button
                onClick={() =>
                  onParkingChange(
                    "semiCovered",
                    formData.parkingOptions.semiCovered - 1
                  )
                }
                className="bg-white w-12 h-[50px] rounded-[10px] border border-slate-200"
              >
                -
              </button>
              <input
                type="text"
                value={formData.parkingOptions.semiCovered}
                readOnly
                className="input-focus text-center w-20 rounded-[10px] py-2"
              />
              <button
                onClick={() =>
                  onParkingChange(
                    "semiCovered",
                    formData.parkingOptions.semiCovered + 1
                  )
                }
                className="bg-white w-12 h-[50px] rounded-[10px] border border-slate-200"
              >
                +
              </button>
            </div>
          </div>

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Open Parking
            </label>
            <div className="col-span-8 flex items-center gap-3">
              <button
                onClick={() =>
                  onParkingChange("open", formData.parkingOptions.open - 1)
                }
                className="bg-white w-12 h-[50px] rounded-[10px] border border-slate-200"
              >
                -
              </button>
              <input
                type="text"
                value={formData.parkingOptions.open}
                readOnly
                className="input-focus text-center w-20 rounded-[10px] py-2"
              />
              <button
                onClick={() =>
                  onParkingChange("open", formData.parkingOptions.open + 1)
                }
                className="bg-white w-12 h-[50px] rounded-[10px] border border-slate-200"
              >
                +
              </button>
            </div>
          </div>

          {selectedPropertyType === "Apartment" && (
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                UDS
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  value={unitInfo?.uds || ``}
                  readOnly
                  className="focus:outline-none px-3 w-full rounded-[10px] py-2 bg-slate-100"
                />
              </div>
            </div>
          )}

          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Unit Facing Side
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={roadFacingSides.map((list) => ({
                  value: list?.id,
                  label: list?.label,
                }))}
                value={
                  unitInfo?.roadFacingSide && {
                    value: unitInfo?.roadFacingSide?.id,
                    label: unitInfo?.roadFacingSide?.name,
                  }
                }
                disabled={true}
                placeholder="Unit Facing Side"
              />
            </div>
          </div>
        </>
      )}

      <div className="flex justify-center mt-3">
        <CustomButton
          label={"Next"}
          className={"w-[320px]"}
          onClick={onGenerate}
        />
      </div>
    </div>
  );
};

export default PropertyInfoStep;
